import { GzDataTableWebComponent } from './component/GzDataTableWebComponent';

export { GzDataTableWebComponent };
